import React from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import Stacey from "../../../assets/judges/stacey.jpg";
import Glover from "../../../assets/judges/glover.jpg";
import Joseph from "../../../assets/judges/joseph.jpg";
import Odeh from "../../../assets/judges/odeh.png";
import Austin from "../../../assets/judges/austin.jpg";

const ourJudges = [
  {
    name: "Odeh Friday",
    title: "Country Director, Accountability Lab Nigeria",
    profile:
      "Country Director at Accountability Lab Nigeria with over 13 years of experience in governance, human rights, and civic engagement. Leads national accountability and anti-corruption programming, including the Integrity Icon program, which promotes ethical leadership in public service and strengthens public trust.",
    profile2:
      "Holds a Master’s degree in Information Technology and a Bachelor’s degree in Mathematics. Has designed and led multi-stakeholder projects connecting citizens, civil society, and government to improve transparency, service delivery, and accountability outcomes.",
    profile3:
      "Previously worked with Save the Children International and the Association of Positive Youth Living with HIV/AIDS in Nigeria. Recognized with the International Anti-Corruption Excellence Award and the MKO Abiola Community Engagement Award. Led the development of Accountability Lab Nigeria’s Rewards and Recognition Toolkit to institutionalize merit and ethics in the public sector.",
    imgpath: Odeh,
  },
  {
    name: "Etemore Glover",
    title: "CEO, Impact Investors’ Foundation (IIF)",
    profile:
      "Etemore Glover is a development finance and impact investing expert committed to driving meaningful social change across Nigeria and Africa. She holds a double honors degree in Economics and Education from Ahmadu Bello University, Zaria, and earned an MBA from the University of Leicester. To deepen her impact in the non-profit and development space, Etemore completed a Postgraduate Certificate in NGO and Development Management from the University of East London, UK.",
    profile2:
      "Widely regarded as a thought leader in impact investing and development finance, Etemore is a UNDP SDG Impact Standards Consultant, a member of the Institute of Directors Nigeria, and a Fellow Africapitalism of The New Institute, Hamburg. In recognition of her contributions, Etemore was honored with the 2025 Women Achievers Africa Changemakers Award.",
    profile3:
      "She also champions the career and personal advancement of Niger Delta women through Kilali Tribe—a dynamic collective of purpose-driven professionals transforming development outcomes in the region—and actively mentors young women through her alma mater. Beyond her advocacy work, she finds joy in exploring new languages, delving into YouTube rabbit holes, and nurturing a lifelong passion for learning and empowerment.",
    imgpath: Glover,
  },
  {
    name: "Joseph Amenaghawon",
    title: "Head, Civic Hive Foundation",
    profile:
      "Joseph Idahosa Amenaghawon is the Strategy and Growth Advisor at BudgiT Foundation. In the last twelve years, he served as the Economic Governance/ Justice Coordinator at the Open Society Initiative for West Africa (OSIWA), where he was actively involved in supporting strategy design and implementation, grant making and grantees supervision, project management, monitoring, evaluation and learning.",
    profile2:
      " Joseph is currently a Doctorate candidate in Development Studies at Atlantic International University. He holds a master’s degree in international law and Diplomacy (MILD) and a bachelor’s degree in Economics.  He has also attended several professional and leadership training courses, including the prestigious Harvard Kennedy School.",
    imgpath: Joseph,
  },

  {
    name: "Stacey Ejiroghene Okparavero ",
    title: "Founder, Atelier Stacey Ravvero",
    profile:
      "Stacey Ejiroghene Okparavero, professionally known as Stacey Ravvero, is a Nigerian artist, writer, and cultural practitioner whose work spans painting, sculpture, poetry, and performance. Her practice explores themes of environment, memory, healing, and human experience through immersive and research-based artworks.",
    profile2:
      "She studied Visual Arts at the University of Lagos and also holds a Postgraduate Diploma from the Institute d’Études supérieure des Arts and a Master’s degree in Art History and Business from the University of Warwick. Her notable works include Ókakò r’Évu (Plant Womb), Leave the Leaves, The Song of the Soil, and The Earth Remembers.",
    profile3:
      "Ravvero is the founder of Atelier Stacey Ravvero, a Lagos-based studio that includes The Phœnix metal fabrication lab and a permaculture garden. Her work combines art, research, and community engagement, contributing to conversations on sustainability and social impact.",
    imgpath: Stacey,
  },
  {
    name: "Dr. Austin Ifedirah",
    title: "Managing Partner, Bandika IoT",
    profile:
      "Dr. Austin Ifedirah MBA, BDS, is Co-Founder and Managing Partner at Bandika IoT where he leads the day-to-day management, development and deployment of the company’s capabilities and platform. Prior to founding Bandika Telematics, Dr. Ifedirah has held several founder and executive positions in the United States.",
    profile2:
      "A serial entrepreneur, Dr. Ifedirah has had several successful exits with these companies. Dr. Ifedirah earned his Master’s in Business Administration (MBA) degree from the Darden Graduate School of Business Administration at the University of Virginia and his Bachelor of Dental Surgery degree from the University of Benin in Nigeria.",
    imgpath: Austin,
  },
];

const Judges2026 = () => {
  const ColorButton = styled(Button)(() => ({
    color: "#049593",
    width: 225,
    height: 65,
    fontWeight: 700,
    fontSize: "16px",
    textTransform: "capitalize",
    backgroundColor: "rgba(0, 0, 0, 0)",
    borderColor: "3px solid #D7A036",
    "&:hover": {
      color: "#fff",
      backgroundColor: "#004165",
      borderColor: "#004165",
    },
  }));

  return (
    <Grid item xs={12} md={12}>
      <Typography
        variant={"body1"}
        fontWeight={500}
        textAlign={"left"}
        padding={{ xs: "0% 0% 10% 0%", sm: "1% 0%" }}
        color={"#4f4f4f"}
        lineHeight={"1.625em"}
      >
        The Active Citizens Awards are judged by an esteemed panel of civic
        leaders and experts. The judging is a rigorous two-stage process
        including pre-scoring to determine shortlists and a judging meeting
        where entries are discussed and evaluated in detail to decide the
        winning nominations.
      </Typography>
      <Grid
        item
        xs={12}
        md={12}
        display={"flex"}
        flexWrap={"wrap"}
        marginTop={"5%"}
      >
        {ourJudges.map((judge, index) => {
          const { name, profile, profile2, profile3, imgpath, title } = judge;
          return (
            <Grid
              key={index}
              item
              xs={12}
              md={3}
              marginBottom={{ xs: "7%", sm: "2%" }}
              marginRight={{ xs: "0%", sm: "2%" }}
              marginLeft={{ xs: "4%", sm: "0%" }}
            >
              <Card sx={{ maxWidth: 360, height: "100%" }}>
                <CardActionArea>
                  <CardMedia
                    component="img"
                    height="340"
                    image={imgpath}
                    sx={{ objectFit: "cover" }}
                    alt={name}
                  />
                  <CardContent>
                    <Typography
                      gutterBottom
                      variant="h5"
                      color={"#004165"}
                      component="div"
                      paddingBottom={"4%"}
                    >
                      {name}
                    </Typography>
                    <Typography
                      paddingBottom={"5%"}
                      variant="body2"
                      color="#D7A036"
                      fontWeight={700}
                      data-aos={"fade-up"}
                    >
                      {title}
                    </Typography>
                    <Typography
                      paddingBottom={"5%"}
                      variant="body1"
                      color="text.secondary"
                      data-aos={"fade-up"}
                    >
                      {profile}
                    </Typography>
                    <Typography
                      paddingBottom={"5%"}
                      variant="body1"
                      color="text.secondary"
                      data-aos={"fade-up"}
                    >
                      {profile2}
                    </Typography>
                    <Typography
                      variant="body1"
                      color="text.secondary"
                      data-aos={"fade-up"}
                    >
                      {profile3}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>
      <Box padding={"5% 2% 1% 0%"} display={"flex"} justifyContent={"center"}>
        <ColorButton
          component={"a"}
          variant="contained"
          size="medium"
          href={"/2023-judges"}
          endIcon={
            <ArrowRightAltIcon
              sx={{
                color: "#049593",
                height: "32px",
                width: "32px",
                "&:hover": {
                  color: "#049593",
                },
              }}
            />
          }
        >
          Meet 2023 Judges
        </ColorButton>
      </Box>
    </Grid>
  );
};

export default Judges2026;
